import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import fastCar from "../../../../assets/svgs/fast-car.svg";

interface DispatchedProps {}

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#00152E",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",

    "@media (max-width: 600px)": {
      width: 320,
      margin: "auto"
    },
  },
  label: {
    fontSize: 26,
    fontWeight: 500,
    fontFamily: "lato",
    color: "white",
    marginRight: 25,
    marginLeft: 25,

    "@media (max-width: 600px)": {
      fontSize: 17,
    },
  },
  carIcon: {
    marginBottom: 30,
    paddingRight: 40,
    width: 190,

    "@media (max-width: 600px)": {
      width: 140,
    },
  },
}));

const Dispatched: React.FC<DispatchedProps> = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={fastCar} className={classes.carIcon} />
      <div className={classes.label}>Thanks for your callout. We’ll be with you as soon as we can.</div>
    </div>
  );
};

export default Dispatched;
